/**
 * @author center
 * @date 2021/5/19-4:52 下午
 * @file a-type
 */
export const GET_MENU_OPEN = 'menu_open/get_menu_open';
